(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[999],{

/***/ 55331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Header": function() { return /* reexport */ Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(46670);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Layout/components/Login/index.js + 9 modules
var Login = __webpack_require__(78497);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/Layout/components/Header/header.module.sass
var header_module = __webpack_require__(23065);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
;// CONCATENATED MODULE: ./components/Layout/components/Header/HeaderSeason/HeaderSeason.jsx






var HeaderSeason = function(param) {
    var isSea = param.isSea, urlBF = param.urlBF;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isSea && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (header_module_default()).ItemWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Anchor */.e, {
                        href: "/2025",
                        variant: "heading-3",
                        className: (0,classcat/* default */.Z)([
                            [
                                (header_module_default()).seasonItem
                            ],
                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                        ]),
                        children: [
                            "Круизы на 2025 год",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (header_module_default()).arrowRight,
                                children: "→"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (header_module_default()).season,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/spring",
                                        variant: "text-4",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Весна"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/spring/april",
                                        variant: "text",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Апрель"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/spring/may",
                                        variant: "text",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Май"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/summer",
                                        variant: "text-4",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Лето"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/summer/june",
                                        variant: "text",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Июнь"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/summer/july",
                                        variant: "text",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Июль"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/summer/august",
                                        variant: "text",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Август"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/autumn",
                                        variant: "text-4",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Осень"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/autumn/september",
                                        variant: "text",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Сентябрь"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/autumn/october",
                                        variant: "text",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Октябрь"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/2025/autumn/november",
                                        variant: "text",
                                        className: (0,classcat/* default */.Z)([
                                            [
                                                (header_module_default()).seasonItem
                                            ],
                                            (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                        ]),
                                        children: "Ноябрь"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginTop: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default()).ItemWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Anchor */.e, {
                                href: "/2026",
                                variant: "heading-3",
                                className: (0,classcat/* default */.Z)([
                                    [
                                        (header_module_default()).seasonItem
                                    ],
                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                ]),
                                children: [
                                    "Круизы на 2026 год",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (header_module_default()).arrowRight,
                                        children: "→"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (header_module_default()).season,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/spring",
                                                variant: "text-4",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Весна"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/spring/april",
                                                variant: "text",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Апрель"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/spring/may",
                                                variant: "text",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Май"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/summer",
                                                variant: "text-4",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Лето"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/summer/june",
                                                variant: "text",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Июнь"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/summer/july",
                                                variant: "text",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Июль"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/summer/august",
                                                variant: "text",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Август"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/autumn",
                                                variant: "text-4",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Осень"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/autumn/september",
                                                variant: "text",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Сентябрь"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/autumn/october",
                                                variant: "text",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Октябрь"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/2026/autumn/november",
                                                variant: "text",
                                                className: (0,classcat/* default */.Z)([
                                                    [
                                                        (header_module_default()).seasonItem
                                                    ],
                                                    (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                                ]),
                                                children: "Ноябрь"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Layout/components/Header/HeaderSeason/index.js


;// CONCATENATED MODULE: ./components/Layout/components/Header/HeaderCruises/HeaderCruises.jsx



// import { useRouter } from 'next/router';









var HeaderCruises = (0,es/* observer */.Pi)(function(param) {
    var isSea = param.isSea, shipsSea = param.shipsSea, popularPopdirs = param.popularPopdirs, urlBF = param.urlBF, isMobile = param.isMobile;
    var allStartCities = isSea || shipsSea ? "/popdir?type=sea" : "/popdir";
    var store = (0,RootStoreProvider/* useMarketingStore */.Ox)();
    (0,react.useEffect)(function() {
        store.setIsSea(isSea);
        store.getRiverDistention();
    }, [
        isSea
    ]);
    // const allCruises =
    //   isSea || shipsSea
    //     ? '/result?type=sea'
    //     : '/result';
    var popularDir = (popularPopdirs === null || popularPopdirs === void 0 ? void 0 : popularPopdirs.popularDirections) || store.popularDirections;
    var startCities = (popularPopdirs === null || popularPopdirs === void 0 ? void 0 : popularPopdirs.departureCities) || store.departureCities;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classcat/* default */.Z)([
            [
                (header_module_default()).dropDownMenu
            ],
            (0,_define_property/* default */.Z)({}, (header_module_default()).dropDownMenuBf, urlBF === "black_friday"), 
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (header_module_default()).dropDownMenuWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            isSea ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                style: {
                                    paddingLeft: 4
                                },
                                variant: "heading-3",
                                children: "Города отправления"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (header_module_default()).seasonItemWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                    href: allStartCities,
                                    variant: "heading-3",
                                    className: (0,classcat/* default */.Z)([
                                        [
                                            (header_module_default()).seasonItem
                                        ],
                                        (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                    ]),
                                    children: "Города отправления →"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (header_module_default()).dropDownMenuFeatures,
                                children: [
                                    startCities === null || startCities === void 0 ? void 0 : startCities.map(function(startCity, key) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: (header_module_default()).dropDownMenuFeature,
                                            itemProp: "name",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/popdir/".concat(startCity.href).concat(isSea ? "" : "/result"),
                                                rel: "noreferrer",
                                                onClick: function() {
                                                    (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_any_city_in_mega_menu");
                                                },
                                                itemProp: "url",
                                                className: urlBF === "black_friday" && (header_module_default()).colorText,
                                                children: startCity.h1
                                            })
                                        }, key);
                                    }),
                                    !isSea && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                        href: "/expeditionsCruise",
                                        color: "primaryColor",
                                        variant: "heading-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: urlBF === "black_friday" ? (header_module_default()).linkWrapperBf : (header_module_default()).linkWrapper,
                                            children: "Экспедиционные круизы →"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            isSea ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                style: {
                                    paddingLeft: 4
                                },
                                variant: "heading-3",
                                children: "Популярные направления"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (header_module_default()).seasonItemWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                    href: "/poproutes",
                                    variant: "heading-3",
                                    className: (0,classcat/* default */.Z)([
                                        [
                                            (header_module_default()).seasonItem
                                        ],
                                        (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                    ]),
                                    children: "Популярные направления →"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (header_module_default()).dropDownMenuFeatures,
                                children: popularDir === null || popularDir === void 0 ? void 0 : popularDir.map(function(popDir, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (header_module_default()).dropDownMenuFeature,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                            href: "/popdir/".concat(popDir.href).concat(isSea ? "" : "/result"),
                                            rel: "nofollow",
                                            onClick: function() {
                                                (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_any_departure_in_mega_menu");
                                            },
                                            className: urlBF === "black_friday" && (header_module_default()).colorText,
                                            children: popDir.h1
                                        })
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSeason, {
                            isSea: isSea,
                            isMobile: isMobile,
                            urlBF: urlBF
                        })
                    })
                ]
            })
        })
    });
});
/* harmony default export */ var HeaderCruises_HeaderCruises = (HeaderCruises);

// EXTERNAL MODULE: ./components/Layout/components/Header/HeaderShips/arraysHeaderShips.js
var arraysHeaderShips = __webpack_require__(44804);
;// CONCATENATED MODULE: ./components/Layout/components/Header/HeaderShips/HeaderShips.jsx










var HeaderShips = function(param) {
    var isSea = param.isSea, shipsSea = param.shipsSea, urlBF = param.urlBF, isMobile = param.isMobile;
    var profitShips = isSea || shipsSea ? arraysHeaderShips/* seaProfitShips */.zA : arraysHeaderShips/* riverProfitShips */.Zu;
    var bestReviewsShips = isSea || shipsSea ? arraysHeaderShips/* seaBestReviewsShips */.ax : arraysHeaderShips/* riverBestReviewsShips */.qs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classcat/* default */.Z)([
            [
                (header_module_default()).dropDownMenu
            ],
            (0,_define_property/* default */.Z)({}, (header_module_default()).dropDownMenuBf, urlBF === "black_friday"), 
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (header_module_default()).dropDownMenuWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (header_module_default()).textWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    variant: "heading-3",
                                    children: "Выгодно"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (header_module_default()).dropDownMenuFeatures,
                                children: profitShips.map(function(ship, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (header_module_default()).dropDownMenuFeature,
                                        itemProp: "name",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                            href: ship.linkProfitShip,
                                            rel: "noreferrer",
                                            onClick: function() {
                                                (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_any_ship_in_column_profit_mega_menu");
                                            },
                                            itemProp: "url",
                                            className: (0,classcat/* default */.Z)([
                                                [
                                                    (header_module_default()).seasonItem
                                                ],
                                                (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                            ]),
                                            children: ship.nameProfitShip
                                        })
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (header_module_default()).textWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    variant: "heading-3",
                                    children: isSea ? "Популярные лайнеры" : "Лучшие отзывы"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (header_module_default()).dropDownMenuFeatures,
                                children: bestReviewsShips.map(function(bestRivShip, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (header_module_default()).dropDownMenuFeature,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                            href: bestRivShip.linkBestRevShip,
                                            rel: "noreferrer",
                                            onClick: function() {
                                                (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_any_ship_in_column_best_review_mega_menu");
                                            },
                                            className: (0,classcat/* default */.Z)([
                                                [
                                                    (header_module_default()).seasonItem
                                                ],
                                                (0,_define_property/* default */.Z)({}, (header_module_default()).seasonBf, urlBF === "black_friday"), 
                                            ]),
                                            children: bestRivShip.nameBestRevShip
                                        })
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (header_module_default()).infoWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Anchor */.e, {
                                        href: isSea ? "/liners" : "/ships",
                                        color: "primaryColor",
                                        rel: "noreferrer",
                                        variant: "heading-3",
                                        onClick: function() {
                                            (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_all_ships_in_mega_menu");
                                        },
                                        className: urlBF === "black_friday" && (header_module_default()).infoWrapperBf,
                                        children: [
                                            "Все ",
                                            isSea ? "лайнеры" : "теплоходы",
                                            " →"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                        variant: urlBF === "black_friday" ? "textBF" : "text-1",
                                        children: [
                                            "Укажите свои пожелания чтобы найти ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "подходящий теплоход"
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var HeaderShips_HeaderShips = (HeaderShips);

// EXTERNAL MODULE: ./providers/SearchStoreProvider.tsx + 5 modules
var SearchStoreProvider = __webpack_require__(27101);
// EXTERNAL MODULE: ./components/Logo/index.js + 1 modules
var Logo = __webpack_require__(5475);
// EXTERNAL MODULE: ./components/Skeleton/SkeletonCover.jsx
var SkeletonCover = __webpack_require__(9792);
// EXTERNAL MODULE: ./utils/isClient.js
var isClient = __webpack_require__(69594);
// EXTERNAL MODULE: ./hooks/useCheckStep1Unregistered.js
var useCheckStep1Unregistered = __webpack_require__(16203);
;// CONCATENATED MODULE: ./components/Layout/components/Header/Header.jsx




















var Header = (0,es/* observer */.Pi)(function(param) {
    var isMobile = param.isMobile, shipsSea = param.shipsSea, isOutsPage = param.isOutsPage, isStep = param.isStep, sea = param.sea, topContent = param.topContent, showTopContent = param.showTopContent, popularPopdirs = param.popularPopdirs, urlBF = param.urlBF;
    var router = (0,next_router.useRouter)();
    var isUnregistered = (0,useCheckStep1Unregistered/* useCheckStep1Unregistered */.w)();
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    var mainResult = (0,SearchStoreProvider/* useSearchStore */.Rp)().mainResult;
    var firstLoading = mainResult.isFirstLoading;
    var type = router.query.type;
    var isSea = sea || type === "sea" || router.asPath.startsWith("/sea_cruise") || router.asPath.startsWith("/sea");
    var currentPage = router.pathname;
    var activePage = router.pathname;
    (0,react.useEffect)(function() {
        mainResult.setLoading();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (0,classcat/* default */.Z)([
            [
                (header_module_default()).wrapper
            ],
            (0,_define_property/* default */.Z)({}, (header_module_default()).wrapperBlackFriday, urlBF === "black_friday"), 
        ]),
        children: [
            !isStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isClient/* isClient */.C && showTopContent && store.isLoggedIn && topContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classcat/* default */.Z)([
                    [
                        (header_module_default()).headerNav
                    ],
                    (0,_define_property/* default */.Z)({}, (header_module_default()).headerNavBf, urlBF === "black_friday"), 
                ]),
                id: "np",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (header_module_default()).header,
                            children: [
                                !store.isB2bMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (header_module_default()).logo,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                                        h: 54,
                                        w: 168,
                                        urlBF: urlBF
                                    })
                                }),
                                !isStep && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (header_module_default()).headerTop,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,classcat/* default */.Z)([
                                                [
                                                    (header_module_default()).contactsBar
                                                ],
                                                (0,_define_property/* default */.Z)({}, (header_module_default()).contactsBarBf, urlBF === "black_friday"), 
                                            ]),
                                            children: [
                                                !isSea && !shipsSea && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (header_module_default()).timeTable,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (header_module_default()).InTimeTable,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                    rightGap: 8,
                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                                        name: "common/timetable",
                                                                        width: 20,
                                                                        height: 20
                                                                    }),
                                                                    title: "Расписание отправлений"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: (header_module_default()).timeTableNone,
                                                                    href: "/departures",
                                                                    rel: "nofollow noreferrer",
                                                                    onClick: function() {
                                                                        (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_departure_schedule");
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                        variant: urlBF === "black_friday" ? "timeTableBf" : "timeTable",
                                                                        children: "РАСПИСАНИЕ ОТПРАВЛЕНИЙ"
                                                                    })
                                                                }),
                                                                urlBF === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                    leftGap: 8,
                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                                        name: "common/orandeArrow",
                                                                        width: 11,
                                                                        height: 10
                                                                    }),
                                                                    height: 11,
                                                                    width: 11,
                                                                    title: "Стрелочка"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                    leftGap: 8,
                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                                        name: "common/arrow",
                                                                        width: 11,
                                                                        height: 10
                                                                    }),
                                                                    height: 11,
                                                                    width: 11,
                                                                    title: "Стрелочка"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "container container--end container--between",
                                                    children: !store.isB2bMode && !isStep && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (header_module_default()).iconsWrapper,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "header-phone",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "tel:84958775834",
                                                                onClick: function() {
                                                                    (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_phone_number");
                                                                },
                                                                style: urlBF === "black_friday" ? {
                                                                    color: "#fff"
                                                                } : {
                                                                    color: "none"
                                                                },
                                                                children: "+7 495 877-58-34"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            itemScope: true,
                                            itemType: "https://schema.org/SiteNavigationElement",
                                            className: (header_module_default()).menu,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (0,classcat/* default */.Z)([
                                                        [
                                                            (header_module_default()).menuItem
                                                        ],
                                                        (0,_define_property/* default */.Z)({}, (header_module_default()).menuItemBf, urlBF === "black_friday"), 
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            weight: "700",
                                                            decoration: "none",
                                                            onClick: function() {
                                                                (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("hover_on_part_cruises");
                                                            },
                                                            variant: currentPage.includes("cruise") && "activePage" || currentPage.includes("/result") && "activePage" || currentPage.includes("/twentyThirdYear") && "activePage" || currentPage.includes("/popdir") && "activePage",
                                                            children: "Круизы"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderCruises_HeaderCruises, {
                                                            isSea: isSea,
                                                            shipsSea: shipsSea,
                                                            popularPopdirs: popularPopdirs,
                                                            isMobile: isMobile,
                                                            urlBF: urlBF
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: (0,classcat/* default */.Z)([
                                                        [
                                                            (header_module_default()).menuItem
                                                        ],
                                                        (0,_define_property/* default */.Z)({}, (header_module_default()).menuItemBf, urlBF === "black_friday"), 
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            weight: "700",
                                                            decoration: "none",
                                                            onClick: function() {
                                                                (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("hover_on_part_ships");
                                                            },
                                                            variant: currentPage.includes("liners") && "activePage" || currentPage.includes("ships") && "activePage",
                                                            children: isSea || shipsSea ? "Лайнеры" : "Теплоходы"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderShips_HeaderShips, {
                                                            isSea: isSea,
                                                            shipsSea: shipsSea,
                                                            isMobile: isMobile,
                                                            urlBF: urlBF
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: (header_module_default()).menuItem,
                                                    itemProp: "name",
                                                    children: !isSea && !shipsSea && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                        weight: "700",
                                                        href: "/discount",
                                                        decoration: "none",
                                                        onClick: function() {
                                                            (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_sale_page");
                                                        },
                                                        style: urlBF === "black_friday" ? {
                                                            color: "#fff"
                                                        } : {
                                                            color: "none"
                                                        },
                                                        itemProp: "url",
                                                        variant: currentPage.includes("discount") && "activePage",
                                                        children: "Скидки и акции"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: (header_module_default()).menuItem,
                                                    itemProp: "name",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                        weight: "700",
                                                        href: "/blog",
                                                        decoration: "none",
                                                        itemProp: "url",
                                                        style: urlBF === "black_friday" ? {
                                                            color: "#fff"
                                                        } : {
                                                            color: "none"
                                                        },
                                                        variant: currentPage.includes("blog") && "activePage",
                                                        children: "Блог"
                                                    })
                                                }),
                                                !store.isB2bMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: (header_module_default()).menuItem,
                                                    itemProp: "name",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                        weight: "700",
                                                        href: "/about",
                                                        decoration: "none",
                                                        onClick: function() {
                                                            (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_about_company");
                                                        },
                                                        itemProp: "url",
                                                        variant: currentPage.includes("about") && "activePage",
                                                        style: urlBF === "black_friday" ? {
                                                            color: "#fff"
                                                        } : {
                                                            color: "none"
                                                        },
                                                        children: "О компании"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: activePage === "/contact" ? (header_module_default()).menuItemActive : (header_module_default()).menuItem,
                                                    itemProp: "name",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                        weight: "700",
                                                        href: "/contact",
                                                        decoration: "none",
                                                        onClick: function() {
                                                            (0,YaAndGaHelper/* YaAndGaHeader */.Uv)("click_contacts_company");
                                                        },
                                                        itemProp: "url",
                                                        variant: currentPage.includes("contact") && "activePage",
                                                        style: urlBF === "black_friday" ? {
                                                            color: "#fff"
                                                        } : {
                                                            color: "none"
                                                        },
                                                        children: "Контакты"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !firstLoading ? !isUnregistered && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default()).actions,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login/* Login */.m, {
                                isMobile: isMobile,
                                isOutsPage: isOutsPage,
                                isStep: isStep,
                                urlBF: urlBF
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (header_module_default()).actions,
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonCover/* SkeletonCover */.B, {
                                    width: 185,
                                    height: 37
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/Layout/components/Header/index.js



/***/ }),

/***/ 23065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_wrapper__63aBI","wrapperBlackFriday":"header_wrapperBlackFriday__fQv8C","textWrapper":"header_textWrapper__u6o5K","header":"header_header__k0rxs","headerTop":"header_headerTop__NC3wt","logo":"header_logo__Zut7H","contactsBar":"header_contactsBar__SccwB","contactsBarBf":"header_contactsBarBf__ZfEAj","headerNav":"header_headerNav___HRd_","headerNavBf":"header_headerNavBf__FSLYk","menu":"header_menu__Wl_6n","menuItem":"header_menuItem__zjClW","menuItemBf":"header_menuItemBf__G1NdZ","dropDownMenuBf":"header_dropDownMenuBf__rAG_C","dropDownMenu":"header_dropDownMenu__rQEVe","actions":"header_actions__cjSX9","dropDownMenuWrapper":"header_dropDownMenuWrapper___it6U","dropDownMenuFeatures":"header_dropDownMenuFeatures__TSaUX","dropDownMenuFeature":"header_dropDownMenuFeature__TCohT","colorText":"header_colorText__9J1Y3","timeTable":"header_timeTable__1Ivvm","InTimeTable":"header_InTimeTable__vM0ew","timeTableNone":"header_timeTableNone__x3AZn","season":"header_season__R6dxf","seasonBf":"header_seasonBf__tlhxY","seasonItem":"header_seasonItem__Tl20y","arrowRight":"header_arrowRight__Cncy2","iconsWrapper":"header_iconsWrapper__7W3qT","linkWrapper":"header_linkWrapper__BQdeS","linkWrapperBf":"header_linkWrapperBf__ZQVEg","seasonItemWrapper":"header_seasonItemWrapper__cQOS_","ItemWrapper":"header_ItemWrapper__ld7ql","infoWrapper":"header_infoWrapper__jcRO0","infoWrapperBf":"header_infoWrapperBf__90Xh2"};

/***/ })

}]);